import React, { useRef, useState } from "react";
import { Modal } from "antd";
import type { DraggableData, DraggableEvent } from "react-draggable";
//import Draggable from "react-draggable";

type ModalProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  title: string;
  content?: React.ReactNode;
  showFooter?: boolean;
  onOk?: () => void;
  width?: number | string;
  cancelText?: string;
  okText?: string;
};

const App: React.FC<ModalProps> = ({
  open,
  setOpen,
  title,
  content,
  showFooter,
  onOk,
  width,
  cancelText,
  okText,
}) => {
  const [disabled, setDisabled] = useState(true);
  const [bounds, setBounds] = useState({
    left: 0,
    top: 0,
    bottom: 0,
    right: 0,
  });
  const draggleRef = useRef<HTMLDivElement>(null!);

  const handleOk = () => {
    onOk?.();
    setOpen(false);
  };

  const handleCancel = (_e: React.MouseEvent<HTMLElement>) => {
    setOpen(false);
  };

  const onStart = (_event: DraggableEvent, uiData: DraggableData) => {
    const { clientWidth, clientHeight } = window.document.documentElement;
    const targetRect = draggleRef.current?.getBoundingClientRect();
    if (!targetRect) {
      return;
    }
    setBounds({
      left: -targetRect.left + uiData.x,
      right: clientWidth - (targetRect.right - uiData.x),
      top: -targetRect.top + uiData.y,
      bottom: clientHeight - (targetRect.bottom - uiData.y),
    });
  };

  return (
    <Modal
      width={width}
      title={
        <div
          style={{ width: "100%", cursor: "move" }}
          onMouseOver={() => {
            if (disabled) {
              setDisabled(false);
            }
          }}
          onMouseOut={() => {
            setDisabled(true);
          }}
          // fix eslintjsx-a11y/mouse-events-have-key-events
          // https://github.com/jsx-eslint/eslint-plugin-jsx-a11y/blob/master/docs/rules/mouse-events-have-key-events.md
          onFocus={() => {}}
          onBlur={() => {}}
          // end
        >
          {title || ""}
        </div>
      }
      open={open}
      onOk={handleOk}
      onCancel={handleCancel}
      cancelText={cancelText || "Cancel"}
      okText={okText || "OK"}
      footer={showFooter ? undefined : null}
      // modalRender={(modal) => (
      //   <Draggable
      //     disabled={disabled}
      //     bounds={bounds}
      //     nodeRef={draggleRef}
      //     onStart={(event, uiData) => onStart(event, uiData)}
      //   >
      //     <div ref={draggleRef}>{modal}</div>
      //   </Draggable>
      // )}
    >
      <div style={{ maxHeight: "70vh", overflowY: "scroll" }}>
        {content || ""}
      </div>
    </Modal>
  );
};

export default App;
